var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import pan from "../../../../../../shared-library/assets/images/SalesJourney/ClientDetails/PanCard.svg";
var DpDetailsCard = function (props) {
    var _a = __read(useState(false), 2), detailsPopup = _a[0], setdetailsPopup = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "dpdetails-card-tiles" },
            React.createElement("div", { className: "DMSan_16_700 txt_blackOne1 dpdetails-cardtileHead" }, props.title),
            React.createElement("div", null, props.isBankDetails ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "d-flex dpdetails-cardtile align-items-center" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-bank" })),
                    React.createElement("div", { className: "DMSan_14_700 txt_blackOne1" }, props.Bankname)),
                React.createElement(Row, { className: "d-flex dpdetails-cardtile dpdetails-banktile" },
                    React.createElement(Row, { className: "displayFlex banktile" },
                        React.createElement(Col, { className: "DMSanN_14_400 txt_secondary-gray px-0 lh-19-6" }, "Account No"),
                        React.createElement(Col, { className: "DMSanN_14_400 txt_blackOne1 px-0 lh-19-6" }, props.accNo)),
                    React.createElement(Row, { className: "displayFlex banktile" },
                        React.createElement(Col, { className: "DMSanN_14_400 txt_secondary-gray px-0 lh-19-6" }, "MICR"),
                        React.createElement(Col, { className: "DMSanN_14_400 txt_blackOne1 px-0 lh-19-6" }, props.micr)),
                    React.createElement(Row, { className: "displayFlex banktile" },
                        React.createElement(Col, { className: "DMSanN_14_400 txt_blackOne1 px-0 lh-19-6 text-break" }, props.bankaddress)),
                    React.createElement(Row, { className: "displayFlex banktile" },
                        React.createElement(Col, { className: "DMSanN_14_400 txt_secondary-gray px-0 lh-19-6" }, "NEFT Code"),
                        React.createElement(Col, { className: "DMSanN_14_400 txt_blackOne1 px-0 lh-19-6" }, props.neftcode))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "d-flex dpdetails-cardtile" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-user2" })),
                    React.createElement("div", { className: "DMSan_14_700 txt_blackOne1 lh-19-6" }, props.name)),
                React.createElement("div", { className: "d-flex dpdetails-cardtile" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-locate-us" })),
                    React.createElement("div", { className: "DMSanN_14_400 lh-19-6 text-break" }, props.address)),
                React.createElement("div", { className: "d-flex dpdetails-cardtile" },
                    React.createElement("img", { src: pan, alt: "pan" }),
                    React.createElement("div", { className: "DMSanN_14_400 lh-19-6" }, props.pan)),
                React.createElement("div", { className: "d-flex dpdetails-cardtile" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-msg" })),
                    React.createElement("div", { className: "DMSanN_14_400 lh-19-6" }, props.email)),
                React.createElement("div", { className: "d-flex dpdetails-cardtile" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-phone1" })),
                    React.createElement("div", { className: "DMSanN_14_400 lh-19-6" }, props.mobile))))))));
};
export default DpDetailsCard;
